import {
  defaultMeasureValueProps,
  IMeasureValue,
  IMeasureValueRecord,
  measureValueFromJSON,
} from "common/records/MeasureValue";
import { Record } from "immutable";

export const measurementLinkFromJSON = (json: Partial<IMeasurementLinkData>): MeasurementLinkRecord => {
  const record: IMeasurementLinkRecord = { ...(json as any) };

  if (json.measure_value) {
    record.measure_value = measureValueFromJSON(json.measure_value);
  } else {
    record.measure_value = measureValueFromJSON(defaultMeasureValueProps);
  }

  if (json.inherited !== undefined) {
    record.inherited = json.inherited;
  } else {
    record.inherited = false;
  }

  return new MeasurementLinkRecord(record);
};

export interface IMeasurementLinkData {
  id: number;
  item_uuid: string;
  measure_value: IMeasureValue;
  kind: MeasurementLinkKind;
  inherited?: boolean;
  org_id: number;
}

export interface IMeasurementLinkRecord {
  id: number;
  item_uuid: string;
  measure_value: IMeasureValueRecord;
  kind: MeasurementLinkKind;
  inherited: boolean;
  org_id: number;
}

type MeasurementLinkKind = "measurement" | "formula" | "interior_measurement" | "interior_formula";

export const defaultMeasurementLinkProps: IMeasurementLinkRecord = {
  id: 0,
  inherited: false,
  item_uuid: "",
  kind: "measurement",
  measure_value: defaultMeasureValueProps,
  org_id: 0,
};

export class MeasurementLinkRecord extends Record(defaultMeasurementLinkProps) implements IMeasurementLinkRecord {}
